import type { LogAuditoria } from './auditoria';

/**
 * Logs específicos de auditoria de configurações
 * Filtrados do log principal + logs detalhados de cada alteração
 */
export interface LogAuditoriaConfiguracao extends LogAuditoria {
  empresaId?: string;
  empresaNome?: string;
  campanhaId?: string;
  campanhaNome?: string;
  participanteId?: string;
  participanteNome?: string;
  chaveConfig?: string;
  valorAnterior?: string;
  valorNovo?: string;
  escopo: 'empresa' | 'campanha' | 'participante';
}

export const logsAuditoriaConfiguracoes: LogAuditoriaConfiguracao[] = [
  {
    id: 'LOG-CFG-001',
    acao: 'alterar_configuracao',
    modulo: 'configuracoes',
    usuario: 'André Costa',
    usuarioRole: 'admin',
    detalhes: 'Alterou taxa_processamento_pix de 2.5% para 2.0% na empresa getPoints',
    data: '2026-05-07T16:20:00Z',
    ip: '192.168.1.100',
    empresaId: 'EMP-001',
    empresaNome: 'getPoints',
    chaveConfig: 'taxa_processamento_pix',
    valorAnterior: '2.5%',
    valorNovo: '2.0%',
    escopo: 'empresa',
    entidadeId: 'EMP-001',
    entidadeTipo: 'empresa',
  },
  {
    id: 'LOG-CFG-002',
    acao: 'alterar_configuracao',
    modulo: 'configuracoes',
    usuario: 'André Costa',
    usuarioRole: 'admin',
    detalhes: 'Alterou limite_resgate_diario de R$ 1.000,00 para R$ 1.500,00 na empresa getPoints',
    data: '2026-05-03T11:00:00Z',
    ip: '192.168.1.100',
    empresaId: 'EMP-001',
    empresaNome: 'getPoints',
    chaveConfig: 'limite_resgate_diario',
    valorAnterior: 'R$ 1.000,00',
    valorNovo: 'R$ 1.500,00',
    escopo: 'empresa',
    entidadeId: 'EMP-001',
    entidadeTipo: 'empresa',
  },
  {
    id: 'LOG-CFG-003',
    acao: 'alterar_configuracao',
    modulo: 'configuracoes',
    usuario: 'Ricardo Ferreira',
    usuarioRole: 'admin',
    detalhes: 'Sobrescreveu taxa_processamento_pix para 1.5% na campanha Inova Digital Rewards (CAMP-003)',
    data: '2026-05-06T14:30:00Z',
    ip: '192.168.1.108',
    empresaId: 'EMP-002',
    empresaNome: 'Inova Digital',
    campanhaId: 'CAMP-003',
    campanhaNome: 'Inova Digital Rewards',
    chaveConfig: 'taxa_processamento_pix',
    valorAnterior: '2.5% (empresa)',
    valorNovo: '1.5%',
    escopo: 'campanha',
    entidadeId: 'CAMP-003',
    entidadeTipo: 'campanha',
  },
  {
    id: 'LOG-CFG-004',
    acao: 'alterar_configuracao',
    modulo: 'configuracoes',
    usuario: 'Fernanda Costa',
    usuarioRole: 'admin',
    detalhes: 'Alterou limite_resgate_mensal de R$ 5.000,00 para R$ 8.000,00 na campanha TechBrasil Premier (CAMP-004)',
    data: '2026-05-04T09:15:00Z',
    ip: '192.168.1.104',
    empresaId: 'EMP-003',
    empresaNome: 'TechBrasil',
    campanhaId: 'CAMP-004',
    campanhaNome: 'TechBrasil Premier',
    chaveConfig: 'limite_resgate_mensal',
    valorAnterior: 'R$ 5.000,00',
    valorNovo: 'R$ 8.000,00',
    escopo: 'campanha',
    entidadeId: 'CAMP-004',
    entidadeTipo: 'campanha',
  },
  {
    id: 'LOG-CFG-005',
    acao: 'alterar_configuracao',
    modulo: 'configuracoes',
    usuario: 'André Costa',
    usuarioRole: 'admin',
    detalhes: 'Personalizou limite_resgate_diario para R$ 5.000,00 do participante João Pedro Silva (PART-C1-001) na campanha getPoints Fidelidade',
    data: '2026-05-01T10:00:00Z',
    ip: '192.168.1.100',
    empresaId: 'EMP-001',
    empresaNome: 'getPoints',
    campanhaId: 'CAMP-001',
    campanhaNome: 'getPoints Fidelidade',
    participanteId: 'PART-C1-001',
    participanteNome: 'João Pedro Silva',
    chaveConfig: 'limite_resgate_diario',
    valorAnterior: 'R$ 1.500,00 (empresa)',
    valorNovo: 'R$ 5.000,00',
    escopo: 'participante',
    entidadeId: 'PART-C1-001',
    entidadeTipo: 'participante',
  },
  {
    id: 'LOG-CFG-006',
    acao: 'alterar_configuracao',
    modulo: 'configuracoes',
    usuario: 'André Costa',
    usuarioRole: 'admin',
    detalhes: 'Personalizou limite_resgate_diario para R$ 8.000,00 e taxa_processamento_pix para 1.0% da participante Maria Fernanda Costa (PART-C1-002) na campanha getPoints Fidelidade',
    data: '2026-05-03T09:15:00Z',
    ip: '192.168.1.100',
    empresaId: 'EMP-001',
    empresaNome: 'getPoints',
    campanhaId: 'CAMP-001',
    campanhaNome: 'getPoints Fidelidade',
    participanteId: 'PART-C1-002',
    participanteNome: 'Maria Fernanda Costa',
    chaveConfig: 'multipla',
    valorAnterior: 'Padrão empresa',
    valorNovo: 'Limite: R$ 8.000, Taxa: 1.0%',
    escopo: 'participante',
    entidadeId: 'PART-C1-002',
    entidadeTipo: 'participante',
  },
  {
    id: 'LOG-CFG-007',
    acao: 'alterar_configuracao',
    modulo: 'configuracoes',
    usuario: 'André Costa',
    usuarioRole: 'admin',
    detalhes: 'Resetou configuração de Carlos Eduardo Mendes (PART-C1-003) na campanha getPoints Fidelidade para padrão da campanha',
    data: '2026-04-10T10:00:00Z',
    ip: '192.168.1.100',
    empresaId: 'EMP-001',
    empresaNome: 'getPoints',
    campanhaId: 'CAMP-001',
    campanhaNome: 'getPoints Fidelidade',
    participanteId: 'PART-C1-003',
    participanteNome: 'Carlos Eduardo Mendes',
    chaveConfig: 'reset',
    valorAnterior: 'Config. personalizada',
    valorNovo: 'Padrão da campanha',
    escopo: 'participante',
    entidadeId: 'PART-C1-003',
    entidadeTipo: 'participante',
  },
  {
    id: 'LOG-CFG-008',
    acao: 'alterar_configuracao',
    modulo: 'configuracoes',
    usuario: 'Ricardo Ferreira',
    usuarioRole: 'admin',
    detalhes: 'Alterou prazo_aprovacao_saque de 48h para 24h na campanha Inova Digital Aniversário (CAMP-005)',
    data: '2026-05-05T16:00:00Z',
    ip: '192.168.1.108',
    empresaId: 'EMP-002',
    empresaNome: 'Inova Digital',
    campanhaId: 'CAMP-005',
    campanhaNome: 'Inova Digital Aniversário',
    chaveConfig: 'prazo_aprovacao_saque',
    valorAnterior: '48h',
    valorNovo: '24h',
    escopo: 'campanha',
    entidadeId: 'CAMP-005',
    entidadeTipo: 'campanha',
  },
  {
    id: 'LOG-CFG-009',
    acao: 'alterar_configuracao',
    modulo: 'configuracoes',
    usuario: 'Ricardo Ferreira',
    usuarioRole: 'admin',
    detalhes: 'Personalizou limite_resgate_diario para R$ 3.500,00 da participante Luciana Torres (PART-C3-001) na campanha Inova Digital Aniversário',
    data: '2026-04-10T09:00:00Z',
    ip: '192.168.1.108',
    empresaId: 'EMP-002',
    empresaNome: 'Inova Digital',
    campanhaId: 'CAMP-005',
    campanhaNome: 'Inova Digital Aniversário',
    participanteId: 'PART-C3-001',
    participanteNome: 'Luciana Torres',
    chaveConfig: 'limite_resgate_diario',
    valorAnterior: 'R$ 1.500,00',
    valorNovo: 'R$ 3.500,00',
    escopo: 'participante',
    entidadeId: 'PART-C3-001',
    entidadeTipo: 'participante',
  },
  {
    id: 'LOG-CFG-010',
    acao: 'alterar_configuracao',
    modulo: 'configuracoes',
    usuario: 'André Costa',
    usuarioRole: 'admin',
    detalhes: 'Aplicou configuração em lote para 5 participantes da empresa getPoints na campanha getPoints Fidelidade — limite_resgate_diario: R$ 4.000,00',
    data: '2026-04-28T11:30:00Z',
    ip: '192.168.1.100',
    empresaId: 'EMP-001',
    empresaNome: 'getPoints',
    campanhaId: 'CAMP-001',
    campanhaNome: 'getPoints Fidelidade',
    chaveConfig: 'limite_resgate_diario',
    valorAnterior: 'Variado',
    valorNovo: 'R$ 4.000,00',
    escopo: 'participante',
    entidadeId: 'CAMP-001',
    entidadeTipo: 'campanha',
  },
  {
    id: 'LOG-CFG-011',
    acao: 'alterar_configuracao',
    modulo: 'configuracoes',
    usuario: 'Fernanda Costa',
    usuarioRole: 'admin',
    detalhes: 'Ativou herança de configurações da empresa na campanha TechBrasil Premier (CAMP-004) — todas as configs voltaram ao padrão da empresa TechBrasil',
    data: '2026-04-20T14:00:00Z',
    ip: '192.168.1.104',
    empresaId: 'EMP-003',
    empresaNome: 'TechBrasil',
    campanhaId: 'CAMP-004',
    campanhaNome: 'TechBrasil Premier',
    chaveConfig: 'heranca',
    valorAnterior: 'Sobrescrita',
    valorNovo: 'Herdar da empresa',
    escopo: 'campanha',
    entidadeId: 'CAMP-004',
    entidadeTipo: 'campanha',
  },
  {
    id: 'LOG-CFG-012',
    acao: 'alterar_configuracao',
    modulo: 'configuracoes',
    usuario: 'Ricardo Ferreira',
    usuarioRole: 'admin',
    detalhes: 'Personalizou limite_resgate_mensal para R$ 15.000,00 e taxa_processamento_pix para 0.8% do participante Carlos Eduardo Mendes (PART-C1-003) na campanha getPoints Premier',
    data: '2026-04-25T16:00:00Z',
    ip: '192.168.1.108',
    empresaId: 'EMP-001',
    empresaNome: 'getPoints',
    campanhaId: 'CAMP-002',
    campanhaNome: 'getPoints Premier',
    participanteId: 'PART-C1-003',
    participanteNome: 'Carlos Eduardo Mendes',
    chaveConfig: 'multipla',
    valorAnterior: 'Padrão campanha',
    valorNovo: 'Limite: R$ 15.000, Taxa: 0.8%',
    escopo: 'participante',
    entidadeId: 'PART-C1-003',
    entidadeTipo: 'participante',
  },
  {
    id: 'LOG-CFG-013',
    acao: 'alterar_configuracao',
    modulo: 'configuracoes',
    usuario: 'André Costa',
    usuarioRole: 'admin',
    detalhes: 'Alterou limite_participantes_profissional de 500 para 750 na empresa getPoints',
    data: '2026-04-15T10:30:00Z',
    ip: '192.168.1.100',
    empresaId: 'EMP-001',
    empresaNome: 'getPoints',
    chaveConfig: 'limite_participantes_profissional',
    valorAnterior: '500',
    valorNovo: '750',
    escopo: 'empresa',
    entidadeId: 'EMP-001',
    entidadeTipo: 'empresa',
  },
  {
    id: 'LOG-CFG-014',
    acao: 'alterar_configuracao',
    modulo: 'configuracoes',
    usuario: 'André Costa',
    usuarioRole: 'admin',
    detalhes: 'Personalizou limite_resgate_diario para R$ 6.000,00 da participante Maria Fernanda Costa (PART-C1-002) na campanha getPoints Premier',
    data: '2026-05-05T11:00:00Z',
    ip: '192.168.1.100',
    empresaId: 'EMP-001',
    empresaNome: 'getPoints',
    campanhaId: 'CAMP-002',
    campanhaNome: 'getPoints Premier',
    participanteId: 'PART-C1-002',
    participanteNome: 'Maria Fernanda Costa',
    chaveConfig: 'limite_resgate_diario',
    valorAnterior: 'R$ 1.500,00',
    valorNovo: 'R$ 6.000,00',
    escopo: 'participante',
    entidadeId: 'PART-C1-002',
    entidadeTipo: 'participante',
  },
];

/** Filtro de logs por empresa */
export function getLogsAuditoriaConfigPorEmpresa(empresaId: string): LogAuditoriaConfiguracao[] {
  return logsAuditoriaConfiguracoes.filter((l) => l.empresaId === empresaId);
}

/** Filtro de logs por campanha */
export function getLogsAuditoriaConfigPorCampanha(campanhaId: string): LogAuditoriaConfiguracao[] {
  return logsAuditoriaConfiguracoes.filter((l) => l.campanhaId === campanhaId);
}

/** Filtro de logs por participante */
export function getLogsAuditoriaConfigPorParticipante(participanteId: string): LogAuditoriaConfiguracao[] {
  return logsAuditoriaConfiguracoes.filter((l) => l.participanteId === participanteId);
}

/** Filtro combinado */
export function filtrarLogsAuditoriaConfig(
  empresaId?: string,
  campanhaId?: string,
  participanteId?: string,
  escopo?: 'empresa' | 'campanha' | 'participante'
): LogAuditoriaConfiguracao[] {
  return logsAuditoriaConfiguracoes.filter((l) => {
    if (empresaId && l.empresaId !== empresaId) return false;
    if (campanhaId && l.campanhaId !== campanhaId) return false;
    if (participanteId && l.participanteId !== participanteId) return false;
    if (escopo && l.escopo !== escopo) return false;
    return true;
  });
}